import { getContext, hasContext, setContext } from 'svelte';
import type { ComparisonContext } from './ComparisonContext';

export type { ComparisonContext };

const KEY: unique symbol = Symbol('comparison_store');

const NO_COMPARISON_CONTEXT: ComparisonContext = {
    comparisonId: null,
    initialized: false,
    selectedVariations: [],
    compareLink: null,
    showComparison: false,
    selectVariation: async () => {
        throw new Error('No comparison context available');
    },
    deselectVariation: async () => {
        throw new Error('No comparison context available');
    },
    clearSelectedVariations: async () => {
        throw new Error('No comparison context available');
    },
};

export function useComparisonContext() {
    if (!hasContext(KEY)) {
        return NO_COMPARISON_CONTEXT;
    }
    return getContext<ComparisonContext>(KEY);
}

export function setComparisonContext(context: ComparisonContext) {
    setContext(KEY, context);
}
